(function () {
  // Shared "gift info" popup used by the free-gift choosers on the PDP (this file),
  // the cart drawer (snippets/sh-cart-drawer.liquid) and the full /cart page
  // (snippets/cart-form-page.liquid). Each surface registers its own trigger click
  // handling, but all three open the same lazily-built modal so there's exactly one
  // DOM node / CSS footprint (assets/sh-gift-chooser.css) regardless of how many
  // surfaces are present on a given page. Guarded so re-running this file (or the
  // identical inline copy in the other two surfaces) never double-registers it.
  if (!window.SHGiftInfoModal) {
    (function () {
      var backdrop, modal, imgEl, titleEl, priceEl, descEl, closeEl;
      function ensureDom() {
        if (modal) return;
        backdrop = document.createElement('div');
        backdrop.className = 'sh-gift-info-backdrop';
        modal = document.createElement('div');
        modal.className = 'sh-gift-info-modal';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.innerHTML =
          '<button type="button" class="sh-gift-info-close" data-sh-gift-info-close>&times;</button>' +
          '<img class="sh-gift-info-image" data-sh-gift-info-image alt="">' +
          '<p class="sh-gift-info-title" data-sh-gift-info-title></p>' +
          '<span class="sh-gift-info-price" data-sh-gift-info-price></span>' +
          '<p class="sh-gift-info-desc" data-sh-gift-info-desc></p>';
        document.body.appendChild(backdrop);
        document.body.appendChild(modal);
        imgEl = modal.querySelector('[data-sh-gift-info-image]');
        titleEl = modal.querySelector('[data-sh-gift-info-title]');
        priceEl = modal.querySelector('[data-sh-gift-info-price]');
        descEl = modal.querySelector('[data-sh-gift-info-desc]');
        closeEl = modal.querySelector('[data-sh-gift-info-close]');
        backdrop.addEventListener('click', close);
        closeEl.addEventListener('click', close);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') close();
        });
      }
      function open(data) {
        ensureDom();
        imgEl.src = data.image || '';
        imgEl.alt = data.title || '';
        titleEl.textContent = data.title || '';
        priceEl.innerHTML = data.priceHtml || '';
        descEl.textContent = data.description || '';
        closeEl.setAttribute('aria-label', data.closeLabel || 'Close');
        backdrop.classList.add('sh-show');
        modal.classList.add('sh-show');
      }
      function close() {
        if (!modal) return;
        backdrop.classList.remove('sh-show');
        modal.classList.remove('sh-show');
      }
      window.SHGiftInfoModal = { open: open, close: close };
    })();
  }

  // Formats an integer cents amount for the NL trust-block installment line
  // (assets/component-pdp.js is only ever asked to recompute this when
  // [data-sh-installment-amount] exists in the DOM, and that element is only ever
  // rendered by snippets/sh-pdp-trust-block.liquid when request.locale.iso_code == 'nl',
  // so this function only ever runs for NL shoppers): fixed 2 decimals, "." thousands
  // separator, "," decimal separator, with a leading "€". Kept in sync with the
  // "€{{ amount | money_without_currency }}" NL-prefix convention already applied across
  // sections/sh-product.liquid and snippets/sh-cart-drawer.liquid, so JS-recomputed
  // amounts render identically to the server-rendered ones.
  function formatMoneyNL(cents) {
    var amount = Math.round(cents) / 100;
    var fixed = amount.toFixed(2);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + intPart + ',' + parts[1];
  }

  function init(root) {
    var gallery = root.querySelector('[data-sh-gal-thumbs]');
    var galMainWrap = root.querySelector('.sh-gal-main');
    if (gallery && galMainWrap) {
      // Third-party product-label apps (e.g. BSS Product Labels & Badges) inject a
      // decorative discount ribbon as an absolutely-positioned, very-high-z-index
      // sibling inside this same container (class .bss_pl_img), meant to overlay a
      // static product photo -- it has no awareness that a video can occupy this
      // slot, so it also sits on top of the video's native controls, including the
      // fullscreen button. It's already aria-hidden and purely decorative, so it
      // should hide for as long as a video is showing. A plain one-time style
      // change isn't enough: this specific badge is a live countdown-timer widget
      // (class bss-countdown-display) that re-renders on its own interval and
      // re-asserts "display:block !important" on the same node each tick, which an
      // external stylesheet can never outrank (inline !important always wins over
      // stylesheet !important). A MutationObserver re-applies the hide every time
      // the widget touches the node (style mutation) or replaces it outright
      // (childList mutation), for as long as suppression is active.
      var badgeSuppressObserver = null;
      function hideBadgeOverlay(el) {
        if (el && el.style.display !== 'none') {
          el.style.setProperty('display', 'none', 'important');
        }
      }
      function suppressBadgeOverlay() {
        hideBadgeOverlay(galMainWrap.querySelector('.bss_pl_img'));
        if (badgeSuppressObserver) return;
        badgeSuppressObserver = new MutationObserver(function () {
          hideBadgeOverlay(galMainWrap.querySelector('.bss_pl_img'));
        });
        badgeSuppressObserver.observe(galMainWrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      }
      function restoreBadgeOverlay() {
        if (badgeSuppressObserver) {
          badgeSuppressObserver.disconnect();
          badgeSuppressObserver = null;
        }
        var el = galMainWrap.querySelector('.bss_pl_img');
        if (el) el.style.removeProperty('display');
      }

      gallery.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        gallery.querySelectorAll('button').forEach(function (b) {
          b.classList.toggle('sh-on', b === btn);
        });
        // A video thumbnail needs the main element itself swapped -- an <img> can't
        // become a <video> by changing its src. The video's full markup (with all
        // sources/poster Shopify generates via the video_tag filter) is cloned from
        // this button's own <template>, mirroring the same clone-and-insert pattern
        // assets/sh-video-card.js uses for the community video cards. Going the
        // other way (video thumb -> image thumb) just swaps back to a plain <img>.
        var current = galMainWrap.querySelector('img, video');
        if (!current) return;
        if (btn.getAttribute('data-type') === 'video') {
          suppressBadgeOverlay();
          var tpl = btn.querySelector('template[data-media-html]');
          if (tpl) {
            var frag = tpl.content.cloneNode(true);
            var video = frag.querySelector('video');
            current.replaceWith(frag);
            // iOS Safari has a well-documented bug where a <video poster> element
            // inserted into the DOM dynamically (rather than present in the initial
            // HTML) renders as a solid black frame instead of its poster image until
            // playback starts. Calling load() re-runs the element's resource-selection
            // algorithm now that it's actually attached to the document, which clears
            // this up reliably.
            if (video) video.load();
          }
        } else {
          restoreBadgeOverlay();
          if (current.tagName === 'IMG') {
            current.src = btn.getAttribute('data-src');
          } else {
            var img = document.createElement('img');
            img.alt = galMainWrap.getAttribute('data-alt') || '';
            img.src = btn.getAttribute('data-src');
            current.replaceWith(img);
          }
        }
      });

      var thumbButtons = Array.prototype.slice.call(gallery.querySelectorAll('button'));
      if (thumbButtons.length > 1) {
        var touchStartX = 0;
        var touchStartY = 0;
        var touching = false;
        galMainWrap.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touching = true;
        }, { passive: true });
        galMainWrap.addEventListener('touchend', function (e) {
          if (!touching) return;
          touching = false;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          var activeIndex = thumbButtons.findIndex(function (b) { return b.classList.contains('sh-on'); });
          if (activeIndex === -1) activeIndex = 0;
          var nextIndex = dx < 0 ? activeIndex + 1 : activeIndex - 1;
          if (nextIndex < 0) nextIndex = thumbButtons.length - 1;
          if (nextIndex >= thumbButtons.length) nextIndex = 0;
          thumbButtons[nextIndex].click();
        }, { passive: true });
      }
    }

    var keyspecs = root.querySelectorAll('.sh-keyspecs .sh-keyspec');
    keyspecs.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          keyspecs.forEach(function (o) {
            if (o !== d) o.open = false;
          });
        }
      });
    });

    var bundleGroup = root.querySelector('[data-sh-bundle-group]');
    var mainAddBtn = root.querySelector('[data-sh-add-to-cart]:not([data-sticky])');
    var stickyAddBtn = document.querySelector('[data-sh-add-to-cart][data-sticky]');
    var stickyPriceLabel = document.querySelector('[data-sh-sticky-price]');
    var mainAddLabel = mainAddBtn ? mainAddBtn.querySelector('[data-sh-add-label]') : null;
    var addToCartLabel = (mainAddLabel ? mainAddLabel.textContent.split('·')[0].trim() : ((window.SH_I18N && window.SH_I18N.add_to_cart_fallback) || 'In winkelwagen'));

    // The trust block's "Betaal in N× ... met Klarna Alma" installment amount lives in the
    // same buy box as the bundle radios and the Add to Cart button, but is rendered by a
    // separate snippet (sh-pdp-trust-block.liquid) that only knows the price at page load.
    // Grab it once here so selecting a different bundle option can keep it in sync too.
    var installmentEl = root.querySelector('[data-sh-installment-amount]');
    var installmentCount = installmentEl ? (parseInt(installmentEl.getAttribute('data-installments'), 10) || 3) : 3;

    function syncAddButton(opt) {
      if (!opt) return;
      var ids = opt.getAttribute('data-variant-ids');
      var total = opt.getAttribute('data-total');
      if (mainAddBtn) {
        mainAddBtn.setAttribute('data-variant-ids', ids);
        if (mainAddLabel) mainAddLabel.textContent = addToCartLabel + ' · ' + total;
      }
      if (stickyAddBtn) stickyAddBtn.setAttribute('data-variant-ids', ids);
      if (stickyPriceLabel) stickyPriceLabel.textContent = total;

      if (installmentEl) {
        var totalCents = parseInt(opt.getAttribute('data-total-cents'), 10);
        if (!isNaN(totalCents)) {
          var perInstallmentCents = Math.round(totalCents / installmentCount);
          installmentEl.textContent = formatMoneyNL(perInstallmentCents);
        }
      }
    }

    if (bundleGroup) {
      bundleGroup.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-sh-bundle-opt]');
        if (!opt) return;
        bundleGroup.querySelectorAll('[data-sh-bundle-opt]').forEach(function (o) {
          o.classList.toggle('sh-sel', o === opt);
        });
        syncAddButton(opt);
      });
      var preselected = bundleGroup.querySelector('.sh-sel:not(:disabled)') || bundleGroup.querySelector('[data-sh-bundle-opt]:not(:disabled)') || bundleGroup.querySelector('[data-sh-bundle-opt]');
      if (preselected) {
        bundleGroup.querySelectorAll('[data-sh-bundle-opt]').forEach(function (o) {
          o.classList.toggle('sh-sel', o === preselected);
        });
      }
      syncAddButton(preselected);
    }

    // Free-gift chooser (treadmill PDPs, France/Suisse market only — see
    // snippets/sh-gift-chooser.liquid). Picking an option doesn't touch price/total:
    // the gift is a genuinely separate line item, zeroed at checkout by an automatic
    // discount (no code) configured against these treadmill and gift products in
    // Shopify admin. We just remember which variant id (if any) to add alongside the
    // treadmill when Add to cart is clicked — the discount applies itself once both
    // items are in the cart, no extra step needed here.
    var giftChooser = root.querySelector('[data-sh-gift-chooser]');
    var selectedGiftVariantId = null;
    if (giftChooser) {
      var giftOptions = Array.prototype.slice.call(giftChooser.querySelectorAll('[data-sh-gift-option]'));
      giftOptions.forEach(function (opt) {
        opt.addEventListener('click', function () {
          var wasSelected = opt.classList.contains('sh-sel');
          giftOptions.forEach(function (o) {
            o.classList.remove('sh-sel');
            o.setAttribute('aria-pressed', 'false');
          });
          if (wasSelected) {
            selectedGiftVariantId = null;
          } else {
            opt.classList.add('sh-sel');
            opt.setAttribute('aria-pressed', 'true');
            selectedGiftVariantId = opt.getAttribute('data-variant-id');
          }
        });
      });

      // Each gift option's product image opens a small "gift info" popup (image,
      // title, struck-through price next to the free label, short description) --
      // it no longer navigates to that gift's own PDP. The trigger sits INSIDE the
      // option's clickable card, so its own activation must stop bubbling up to the
      // `opt.addEventListener('click', ...)` handler above -- otherwise opening the
      // popup would also toggle that gift's selection on this page. It's a <span
      // role="button"> rather than a real <button> (see the comment in
      // sh-gift-chooser.liquid) to avoid the browser auto-closing the outer option
      // <button> when it parses a nested one, so Enter/Space activation is wired up
      // here manually alongside the click handler.
      var giftInfoTriggers = Array.prototype.slice.call(giftChooser.querySelectorAll('[data-sh-gift-info-trigger]'));
      function openGiftInfo(trigger) {
        window.SHGiftInfoModal.open({
          image: trigger.getAttribute('data-gift-image'),
          title: trigger.getAttribute('data-gift-title'),
          priceHtml: '<s>' + (trigger.getAttribute('data-gift-price') || '') + '</s><span class="sh-gift-free">' + (trigger.getAttribute('data-gift-free-label') || '') + '</span>',
          description: trigger.getAttribute('data-gift-description'),
          closeLabel: trigger.getAttribute('data-gift-close-label')
        });
      }
      giftInfoTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.stopPropagation();
          openGiftInfo(trigger);
        });
        trigger.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
          e.preventDefault();
          e.stopPropagation();
          openGiftInfo(trigger);
        });
      });
    }

    var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    document.querySelectorAll('[data-sh-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var ids = btn.getAttribute('data-variant-ids').split(',').filter(Boolean);
        // Snapshot now, synchronously, rather than reading selectedGiftVariantId again
        // inside the .then() below — the shopper could in principle toggle a gift
        // option again while the add-to-cart request is still in flight.
        var giftVariantForThisClick = selectedGiftVariantId;
        var giftWasSelected = !!giftVariantForThisClick && ids.indexOf(giftVariantForThisClick) === -1;
        if (giftWasSelected) {
          ids = ids.concat([giftVariantForThisClick]);
        }
        var items = ids.map(function (id) {
          return { id: parseInt(id, 10), quantity: 1 };
        });
        btn.disabled = true;
        fetch(shopifyRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart add failed');
            btn.disabled = false;
            // Phase 2 video attribution: this is the site's main add-to-cart path
            // (the PDP buy box and its sticky-bar twin both use [data-sh-add-to-cart]),
            // so it has to carry the same sh_video crediting as the plain-form and
            // quick-add paths handled in snippets/sh-cart-drawer.liquid. Centralized
            // there as window.SHCart.attributeAddToCart rather than duplicated here.
            if (window.SHCart && window.SHCart.attributeAddToCart) {
              window.SHCart.attributeAddToCart();
            }
          })
          .then(function () {
            if (window.SHCart) {
              window.SHCart.refresh().then(window.SHCart.open);
            } else {
              window.location.href = shopifyRoot + 'cart';
            }
          })
          .catch(function () {
            btn.disabled = false;
          });
      });
    });

    var stickybar = document.querySelector('[data-sh-stickybar]');
    // The sticky bar is visible at all times, including immediately on page load,
    // and is only hidden while a REAL buy button is already on screen -- either
    // the main buy-box add-to-cart button near the top, or the final CTA
    // section's own button near the bottom -- so it never sits on top of (or
    // right next to) an actual CTA the shopper can already see. It reappears
    // again as soon as neither is in view. Computed directly from live geometry
    // on every scroll/resize (rAF-throttled) rather than via IntersectionObserver,
    // to avoid observer-initialization timing/threshold-crossing edge cases.
    if (stickybar) {
      var finalCtaTarget = document.querySelector('[data-sh-final-cta-btn]') || document.querySelector('[data-sh-final-cta]');
      var ticking = false;

      function isOnScreen(el) {
        if (!el) return false;
        var r = el.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      }

      function computeStickybar() {
        ticking = false;
        var anyCtaInView = isOnScreen(mainAddBtn) || isOnScreen(finalCtaTarget);
        stickybar.classList.toggle('sh-show', !anyCtaInView);
      }

      function onScrollOrResize() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(computeStickybar);
        }
      }

      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);
      computeStickybar();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-sh-pdp-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
